/* tslint:disable */
/* eslint-disable */
/**
 * CipherMail back-end API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const MissingKeyAlias = {
    Allowed: 'ALLOWED',
    NotAllowed: 'NOT_ALLOWED'
} as const;

export type MissingKeyAlias = typeof MissingKeyAlias[keyof typeof MissingKeyAlias];



